import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

import { StorageEnum } from '@/enums/storage'
import { Course } from '@/domain/entities/course.entity'

export const courseStore = create(
  persist<CourseStore>(
    (set) => ({
      course: undefined,
      courses: undefined,
      setCourse: (course: Course) => {
        set({ course })
      },
      setCourses: (courses: Course[]) => {
        set({ courses })
      },
    }),
    {
      name: StorageEnum.course,
      storage: createJSONStorage(() => localStorage),
    },
  ),
)

type CourseStore = {
  course: Course | undefined
  courses: Course[] | undefined
  setCourse: (course: Course) => void
  setCourses: (course: Course[]) => void
}
